/**
 * AI Scribe V2 — recover a persisted session
 *
 * Decryption is async, so the restored snapshot cannot seed `useScribeSession`
 * synchronously. This hook resolves it after mount and reports `undefined` while
 * decrypting — the window withholds the session until it settles to the snapshot
 * (or `null` when there is nothing to recover).
 */

import { useEffect, useState } from "react";
import { readScribeSnapshot } from "./scribe-session-storage";
import { ScribeSessionSnapshot } from "./types";

export const useRestoredSnapshot = (
  sessionKey: string | undefined,
  enabled: boolean
): ScribeSessionSnapshot | null | undefined => {
  const [snapshot, setSnapshot] = useState<
    ScribeSessionSnapshot | null | undefined
  >(undefined);

  useEffect(() => {
    if (!enabled) return;
    let active = true;
    void readScribeSnapshot(sessionKey).then((result) => {
      if (active) setSnapshot(result);
    });
    return () => {
      active = false;
    };
  }, [sessionKey, enabled]);

  return snapshot;
};
